export default __webpack_public_path__ + "static/media/transfer2.46951011.svg";